const setLineAttributes = (itemId, markerStart, markerEnd, strokeDasharray, color, thickness) => {
  const target = document.querySelector(`#draggable-item-container-${itemId}`);
  if (!target) return;

  const line = target.querySelector('line');
  if (!line) return;

  // Use timestamp for cache busting on Safari
  const timestamp = Date.now();
  const defs = target.querySelector('defs');

  // Update marker IDs with timestamp
  if (defs) {
    const markers = defs.querySelectorAll('marker');
    markers.forEach((marker) => {
      const oldId = marker.id;
      const markerType = oldId.split('-')[0]; // arrow, dot, or square
      const newId = `${markerType}-${itemId}-${timestamp}`;
      marker.id = newId;
    });
  }

  // Store line attributes
  const x1 = line.getAttribute('x1');
  const y1 = line.getAttribute('y1');
  const x2 = line.getAttribute('x2');
  const y2 = line.getAttribute('y2');
  const lineId = line.id;
  const lineClass = line.className.baseVal;
  const dataItemId = line.getAttribute('data-item-id');
  const dataReflex = line.getAttribute('data-reflex-dataset');

  // Remove and re-create the line element to force Safari to re-render
  const parent = line.parentNode;
  line.remove();

  const newLine = document.createElementNS('http://www.w3.org/2000/svg', 'line');
  newLine.setAttribute('x1', x1);
  newLine.setAttribute('y1', y1);
  newLine.setAttribute('x2', x2);
  newLine.setAttribute('y2', y2);
  newLine.setAttribute('id', lineId);
  newLine.setAttribute('class', lineClass);
  newLine.setAttribute('data-item-id', dataItemId);
  if (dataReflex) newLine.setAttribute('data-reflex-dataset', dataReflex);

  newLine.setAttribute('marker-start', `url(#${markerStart}-${itemId}-${timestamp})`);
  newLine.setAttribute('marker-end', `url(#${markerEnd}-${itemId}-${timestamp})`);
  newLine.setAttribute('stroke-width', thickness);
  newLine.setAttribute('stroke-dasharray', `${strokeDasharray.split(',')[0] * thickness} ${strokeDasharray.split(',')[1] * thickness}`);
  newLine.setAttribute('stroke', color);
  newLine.setAttribute('fill', color);

  parent.appendChild(newLine);

  // Set color on markers
  const markers = target.querySelectorAll('marker path, marker circle, marker rect');
  markers.forEach((marker) => {
    marker.setAttribute('fill', color);
  });

  target.setAttribute('data-marker-start', markerStart);
  target.setAttribute('data-marker-end', markerEnd);
  target.setAttribute('data-stroke-dasharray', strokeDasharray);
  target.setAttribute('data-color', color);
  target.setAttribute('data-thickness', thickness);
};

export default setLineAttributes;
